module.exports = __webpack_public_path__ + "media/images/icon/file-download-50e2e1f0ae34ab5fb2c21f94927db29b.svg";